<script lang="ts" setup>
import type { OwnerCompany } from "@/api/users/dto/owner.dto";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useFilters } from "@/composables";

const { t } = useI18n();
const { date } = useFilters();

const props = withDefaults(
  defineProps<{
    company: OwnerCompany;
    hideDocNumber?: boolean;
    hideInsuranceExpExp?: boolean;
  }>(),
  {
    hideDocNumber: false,
    hideInsuranceExpExp: false,
  },
);

const fullAddress = computed(() => {
  const { addressCity, addressState, addressZipCode, addressCountry } = props.company;

  return [addressCity, addressState && `${addressState} ${addressZipCode}`, addressCountry].filter(Boolean).join(", ");
});
</script>

<template>
  <div>
    <div class="text-grey-darken-3 font-weight-500">{{ props.company.name }}</div>

    <div class="d-flex align-center mt-3 col-gap-2">
      <v-icon class="text-grey-darken-2" size="16">mdi-map-marker-radius-outline</v-icon>
      <span class="font-size-12 text-grey-darken-1">{{ fullAddress }}</span>
    </div>

    <div v-if="!hideDocNumber" class="d-flex align-center col-gap-3 mt-4">
      <span class="font-size-12 text-grey-darken-1">{{ t("general.doc-number") }}</span>
      <span class="text-grey-darken-3">{{ company.documentNumber }}</span>
    </div>

    <div v-if="!hideInsuranceExpExp" class="d-flex align-center col-gap-3 mt-4">
      <span class="font-size-12 text-grey-darken-1">{{ t("general.insurance-exp") }}</span>
      <span class="text-grey-darken-3">{{ date(company.insuranceExpireDate) }}</span>
    </div>
  </div>
</template>
